<template>
    <BlocksAnimation v-if="block?.QuoteItems?.length > 0" class="container mx-auto">
        <Slider data-quote :options="options" :class="{'can-swipe': block.QuoteItems.length > 1}">
            <div
                v-for="(quote, index) in block.QuoteItems"
                :key="index"
                class="swiper-slide surface-background"
            >
                <div
                    class="flex flex-col space-y-6 py-3 lg:py-0 h-full"
                    :class="{
                        'text-center items-center justify-center': block.Alignment === 'centred',
                        'lg:py-12': block.fullWidthBackground
                    }"
                >

                    <template v-if="block.Alignment === 'centred'">
                        <div v-if="quote.quoteItem_Image.length > 0 && quote.quoteItem_Graphic === 'image'" class="w-9 h-9 rounded-full overflow-hidden">
                            <img :src="quote.quoteItem_Image[0]?.url">
                        </div>
                        <div v-else-if="quote.quoteItem_Graphic === 'icon'" class="w-9 h-9 flex items-center justify-center">
                            <DIcon
                                :icon="quote.quoteItem_Icon.name"
                                :icon-set="quote.quoteItem_Icon.set"
                                :type="quote.quoteItem_Icon.type"
                                size="w-7 h-7"
                                class="shape-brand-accent"
                            />
                        </div>
                    </template>

                    <p
                        class="text-neutral-subtle font-brand-primary"
                        :class="{
                            'text-lg leading-lg font-medium': block.TextSize !== 'large',
                            'text-2xl leading-2xl font-semibold': block.TextSize === 'large',
                        }"
                    >
                        {{ quote.quoteItem_Text }}
                    </p>

                    <div v-if="block.Alignment === 'left'" class="flex items-center space-x-3">
                        <div v-if="quote.quoteItem_Image.length > 0 && quote.quoteItem_Graphic === 'image'" class="w-12 h-12 flex-shrink-0 rounded-full overflow-hidden">
                            <img :src="quote.quoteItem_Image[0]?.url">
                        </div>
                        <div v-else-if="quote.quoteItem_Graphic === 'icon'" class="w-12 h-12 flex items-center justify-center flex-shrink-0">
                            <DIcon
                                :icon="quote.quoteItem_Icon.name"
                                :icon-set="quote.quoteItem_Icon.set"
                                :type="quote.quoteItem_Icon.type"
                                size="w-8 h-8"
                            />
                        </div>

                        <div class="text-neutral-subtle">
                            <p class="text-base leading-base font-semibold font-ux">
                                {{ quote.quoteItem_AuthorName }}
                            </p>

                            <p v-if="quote.quoteItem_AuthorDetail?.length > 0" class="text-sm leading-sm mt-1 font-ux">{{ quote.quoteItem_AuthorDetail }}</p>
                        </div>
                    </div>

                    <div v-else class="flex items-center justify-center space-x-3 w-full">
                        <div class="text-neutral-subtle flex items-center justify-center gap-3 w-full">
                            <p class="text-base leading-base font-semibold font-ux flex-shrink-0">
                                {{ quote.quoteItem_AuthorName }}
                            </p>

                            <p v-if="quote.quoteItem_AuthorDetail?.length > 0" class="text-sm leading-sm font-ux pl-3 border-l border-base text-left">
                                {{ quote.quoteItem_AuthorDetail }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <template #navigation>
                <div class="relative mt-10 lg:mx-16">
                    <div class="swiper-pagination" :class="{'!text-left': block.Alignment === 'left'}" />
                </div>

                <div class="button-prev absolute top-1/2 -translate-y-1/2 z-10 opacity-0 lg:opacity-100 left-0">
                    <DButton
                        size="lg"
                        icon="caret-left"
                        icon-set="ph"
                        theme="transparent"
                    />
                </div>

                <div class="button-next absolute top-1/2 -translate-y-1/2 z-10 opacity-0 lg:opacity-100 right-0">
                    <DButton
                        size="lg"
                        icon="caret-right"
                        icon-set="ph"
                        theme="transparent"
                    />
                </div>
            </template>
        </Slider>
    </BlocksAnimation>
</template>

<script setup>
    import { DIcon, DButton } from '@digistorm/spark'

    defineProps({
        id: String,
        block: Object
    })

    const options = ref({
        effect: 'fade',
    })

</script>

<style lang="scss">
    [data-quote] {
        &.can-swipe {
            .swiper {
                @apply px-4 lg:px-16;
                .swiper-wrapper {
                    @apply items-stretch;
                    .swiper-slide {
                        @apply h-auto;
                    }
                }
            }
        }
        .swiper-pagination {
            --swiper-pagination-color: var(--color-accent);
            --swiper-pagination-bullet-inactive-color: var(--text-neutral-extra-subtle);
            &[data-mode*='base-invert'] {
                --swiper-pagination-color: var(--text-neutral-strong);
            }
        }
    }
</style>
